// Browser screenshots belong to execution output, not editable canvas versions.
export function canvasSaveState<T>(state: T): T {
  return JSON.parse(JSON.stringify(state, (key, value) => {
    if (key !== 'scriptExecutions' || !Array.isArray(value)) return value;
    return JSON.parse(JSON.stringify(value, (field, entry) =>
      field === 'screenshot' ? undefined : entry));
  }));
}
